import { useMutation } from 'react-query';
import { deleteDemand } from 'src/services/api/demands';

function useDeleteDemand() {
  return useMutation(({ demand, doctorId }) => deleteDemand(demand, { doctorId }));
}

export default useDeleteDemand;
